export const CodeInactivationTypeEnum = {
  BUTTON: 'button',
  INPUT_CODE: 'input'
};
